import React, { useRef, useState } from "react";
import twynLogo from "./assets/twyn-logo.png";

export const TERMS_ACCEPTANCE_STORAGE_KEY =
  "twyn-terms-2026-pages-3-8-accepted";

const introductoryParagraphs = [
  <>
    These terms and conditions and the Proposal for Services to which they are
    attached (the <strong>“Proposal for Services”</strong>) form the{" "}
    <strong>“Agreement”</strong>. The following definitions shall apply:
  </>,
  <>
    <strong>“Strategic Data Asset”</strong> means the proprietary, exclusively
    licensed synthetic population data and statistical models made available by
    9F.
  </>,
];

const termsSections = [
  {
    number: "1",
    title: "Services to be Provided.",
    clauses: [
      {
        letter: "a",
        title: "Professional Services.",
        text: "9F shall perform the professional services listed in the Proposal for Services, using the personnel indicated in the Proposal for Services.",
      },
      {
        letter: "b",
        title: "No Additional Services.",
        text: "The “Services” are comprised of the services described in 1(a), above. No additional services are included. The Proposal for Services may only be modified as mutually agreed by the parties in writing and such modification shall be effective as of the execution of such by the Client and 9F.",
      },
    ],
  },
  {
    number: "2",
    title: "Billing and Payment.",
    clauses: [
      {
        letter: "a",
        title: "Fees.",
        text: "In full consideration of the Services, 9F shall invoice Client in accordance with the rates and charges set forth in the Proposal for Services, as attached hereto, and Client shall pay to 9F all such invoiced amounts in the manner further described herein. 9F shall issue invoices on the earlier of (i) the completion of the Services or (ii) at the end of every two (2) or four (4) week period (to be determined from time-to-time in 9F’s sole discretion). Client shall be responsible for, and shall bear the cost of, any service, sales or related taxes imposed on 9F related to 9F’s performance of the Services. All undisputed invoiced amounts will be made by Client within thirty (30) days of receipt of the applicable invoice. To the extent Client requires that 9F incur expenses in connection with the provision of Services, Client shall reimburse 9F for such expenses (provided that 9F provides reasonable documentation thereof).",
      },
      {
        letter: "b",
        title: "General.",
        text: "In the event Client fails to make timely payments on undisputed invoiced amounts, Client may be required, at 9F’s discretion, to pay interest on such untimely unpaid amounts at the rate of one and one half percent (1.5 %) or the maximum amount permitted by law, whichever is less. All invoice disputes must be raised by Client, with a detailed explanation for such dispute, in writing within fifteen (15) days of receipt of the applicable invoice. In no event may Client withhold undisputed amounts. Should payment not be received by 9F when due, and such failure continues for thirty (30) days, 9F may, without waiving any other claim or right 9F may have against Client, terminate its performance of Services and Client will remain liable for all amounts due under this Agreement for Services performed (including related expenses) through the date of termination, plus 9F’s reasonable expenses incurred due to such termination.",
      },
    ],
  },
  {
    number: "3",
    title: "Intellectual Property.",
    clauses: [
      {
        letter: "a",
        title: "License to Deliverables.",
        text: "To the extent 9F produces written work product for Client as part of Professional Services (“Deliverables”), Client shall own the tangible copy of such Deliverables, effective upon Client payment in full of all amounts due. Client acknowledges that ownership of the Deliverables is non-exclusive regarding the underlying factual conclusions, as the Deliverables are derived from the standardized Strategic Data Asset which may yield similar results for third parties.",
      },
      {
        letter: "b",
        title: "Acknowledgement.",
        text: "Client also acknowledges and agrees that 9F is in the business of providing the Services, and as such, will retain the unlimited right to use and to sublicense to others the ideas, designs, concepts, techniques or other expertise which 9F may develop or employ in providing the Services, including those ideas, concepts, techniques acquired in developing any Deliverables, in any products and for any purposes (including providing services and developing deliverables and design guides for other customers), provided that the same do not contain Client Confidential Information.",
      },
      {
        letter: "c",
        title: "Ownership.",
        text: "(i) Strategic Data Asset. Client acknowledges that the Strategic Data Asset is owned by a third-party licensor and is made available to Client under an exclusive license to 9F. Client is granted no rights to the Strategic Data Asset other than the right to access it through the platform as permitted herein. (ii) Generated Insights. Client shall own the specific reports and other analytical outputs generated by Client on a non-exclusive basis. Client acknowledges that the Strategic Data Asset may yield the same or similar Generated Insights for other 9F clients. 9F retains the right to generate and provide the same or similar insights to any other party.",
      },
      {
        letter: "d",
        title: "Feedback.",
        text: "Client acknowledges that any suggestions, comments, improvements, ideas, or feedback provided to 9F (the “Feedback”) are voluntarily provided, and Client agrees that the Feedback may be used by 9F without compensation, accounting or attribution to Client.",
      },
    ],
  },
  {
    number: "4",
    title: "Liability, Standard of Care, and Disclaimers.",
    clauses: [
      {
        letter: "a",
        title: "Limitation of Liability.",
        text: "In no event shall 9F be liable to Client or any third party for any indirect, incidental, punitive, special or consequential damages arising out of or relating to this Agreement, including without limitation loss of or damage to data, loss of profits, loss of goodwill, or other economic loss, whether in contract, tort (including negligence and strict liability), or otherwise, even if 9F has been advised of the possibility of such damages. The aggregate and cumulative liability of 9F to Client or any third party for all damages arising out of or relating to this Agreement shall in no event exceed the amount of fees paid by Client to 9F under this Agreement during the six (6) months immediately preceding the cause of action. Client agrees that none of 9F’s directors, officers, employees or agents (“9F Agents”) may be subject to personal liability for any of 9F’s acts or omissions and Client further covenants not to sue personally any such 9F Agents. Client agrees that this Section is essential to the Agreement and that the provisions included herein accurately reflect the allocation of risk and liability as agreed by the parties and as further reflected in the price of 9F’s services as set forth herein.",
      },
      {
        letter: "b",
        title: "Standard of Care.",
        text: "9F shall use commercially reasonable efforts to perform the Services in accordance with industry standards, and 9F makes no other warranties, either express or implied, as to any other matter whatsoever in connection with this Agreement, including, without limitation, services, information and deliverables, and 9F hereby expressly disclaims all implied warranties including those of merchantability, fitness for any particular purpose or need, accuracy, non-infringement of third party rights and title, and any warranties that may arise from course of dealing, course of performance or usage of trade. Client must report any deficiency in Services to 9F in writing within thirty (30) days of completion of such Services. For any breach of the above warranty, 9F will, at its option and at no additional cost to Client, provide remedial services necessary to enable the Services to conform to the warranty. Client will provide 9F with a reasonable opportunity to remedy any breach and reasonable assistance in remedying any defects. In no event shall 9F be responsible for the supervision, control or performance of any contractor engaged by or utilized by Client, its subcontractors, or any of its or their employees or customers, and in no event shall any such contractor be considered an employee or agent of 9F, and 9F shall not be responsible for such contractor’s failure to comply with any applicable law, regulation or operating procedure or requirements or for the safety or health of any personnel performing Services. In no event shall 9F be responsible for any delays caused by events or factors which are beyond its reasonable control or which 9F could not have reasonably foreseen as of the effective date of this Agreement or prepared for.",
      },
      {
        letter: "c",
        title: "Disclaimers.",
        text: "To the maximum extent permitted by applicable law, 9F provides the services and strategic data asset “as is” without warranty of any kind. 9F disclaims all warranties, whether express or implied, including any warranties of merchantability, fitness for a particular purpose, title, accuracy, and non-infringement. Client acknowledges that the strategic data asset is based on a synthetic statistical model and should not be the sole basis for any business decision. 9F expressly disclaims all liability for client’s business decisions or outcomes. Client is solely responsible for verifying the accuracy of information and for all of its own decisions or actions.",
      },
      {
        letter: "d",
        title: "Public Statements.",
        text: "Client acknowledges and agrees 9F and its personnel may make public or private statements, offer opinions or advice in a public or private forum, or take public or private positions, in each case on issues relating to the subject matter of the Services and related matters. Client acknowledges and agrees that so long as such statements are general and not directed at or specifically critical of Client, Client is barred from making any claim against 9F, and hereby releases 9F from any claim, in respect of any of the foregoing (including, for example and without limitation, in a situation where 9F or 9F personnel publicly or privately advocates a course of action that is different from a course of action that Client has chosen to take).",
      },
    ],
  },
  {
    number: "5",
    title: "Indemnity.",
    clauses: [
      {
        letter: "a",
        title: "Indemnification.",
        text: 'Client shall defend 9F and its respective directors, officers, employees, representatives and agents (the "9F Parties") from all claims, demands, actions or other proceedings (collectively, "Claims") made or instituted by any third party against any of them and arising out of willful misconduct, gross negligence or breach of this Agreement by Client or its employees, agents or contractors ("Indemnified Claims"), and Client shall indemnify and hold harmless the 9F Parties from and against all losses, liabilities, damages and expenses (including reasonable attorneys\' fees and costs) ("Losses") awarded to such third party by an arbitrator or court of competent jurisdiction or in a settlement approved by Client, as a result of such Indemnified Claims.',
      },
      {
        letter: "b",
        title: "Procedure.",
        text: "In connection with making a claim for indemnification hereunder 9F shall provide (i) prompt written notice of any such claim is given (except that this obligation shall only limit Client defense and indemnification obligations hereunder to the extent such failure materially prejudices Client defense of such action), (ii) Client with sole control of the defense and settlement of the applicable indemnified claims (so long as any such settlement does not impose any admissions, restrictions or liability on 9F) and (iii) all reasonably requested cooperation and assistance in connection with the defense of such claim, at Client expense. Client will have the right to control of the defense and settlement in consultation with 9F of all claims for which it is responsible for indemnification. Client shall not settle or compromise such a claim in any manner that would impose any obligation on 9F or otherwise have an adverse effect on 9F’s rights or interest, without the prior written consent of 9F. 9F will have the right to employ separate counsel at 9F’s expense to participate in the defense of the applicable claim for which indemnity is being sought, subject to Client control of such defense.",
      },
      {
        letter: "c",
        title: "Additional Coverage.",
        text: "If, for any reason, any 9F Party serves as a witness or non-party participant in connection with any dispute, litigation or investigation involving Client or the Services provided hereunder, then Client agrees to reimburse such 9F Party for all of its out-of-pocket costs (including travel costs and reasonable attorneys’ fees and costs) and for all its staff members’ time, including travel time, at standard hourly rates in effect at the time rendered to the extent such 9F Party attends, prepares for, or participates in any investigations, audits, submissions of information, meetings, hearings, depositions, trials, or any other proceedings.",
      },
    ],
  },
  {
    number: "6",
    title: "Confidentiality.",
    clauses: [
      {
        letter: "a",
        title: "Confidentiality Obligation.",
        text: 'Each party (the "Receiving Party") will keep strictly confidential any information disclosed in writing, orally or in any other manner by the other Party (the "Disclosing Party") or otherwise made available to the Receiving Party concerning the Disclosing Party\'s performance of this Agreement or otherwise concerning the business, operations, trade secrets or other proprietary information of the Disclosing Party (collectively, and including any summaries, copies or derivative works thereof, "Confidential Information"), using at least the same degree of care that it uses to protect its own confidential or proprietary information, which will be no less than a reasonable degree of care. This Agreement will be deemed to be Confidential Information of each Party. Confidential Information will not include information: (i) which is or becomes generally available to the public other than as a result of disclosure thereof by the Receiving Party in violation of this Section; (ii) which is lawfully received by the Receiving Party on a nonconfidential basis from a Third Party that is not itself under any obligation of confidentiality or nondisclosure to the Disclosing Party with respect to such information; (iii) which by written evidence can be shown by the Receiving Party to have been independently developed by the Receiving Party; or (iv) which the Receiving Party establishes by competent proof was in its possession at the time of disclosure by the Disclosing Party.',
      },
      {
        letter: "b",
        title: "Nondisclosure and Nonuse of Confidential Information.",
        text: "The Receiving Party will use Confidential Information solely for the purposes of performing this Agreement and not for any other purpose, and will not disclose or disseminate any Confidential Information to any individual or entity at any time, except for disclosure to those of its directors, officers, employees, accountants, attorneys, advisers and agents who have a reasonable need to know in furtherance of this Agreement; provided that such directors, officers, employees, accountants, attorneys, advisers and agents are bound in writing to maintain the confidentiality of such Confidential Information to the same extent as if they were the Receiving Party. Each Party may disclose this Agreement to actual or bona fide potential investors, financing sources or acquirers which are required to maintain the confidentiality of this Agreement to the same extent as if they were the Receiving Party.",
      },
      {
        letter: "c",
        title: "Exception.",
        text: "The foregoing confidentiality and nondisclosure obligations will not prohibit the disclosure of Confidential Information to the extent such disclosure is required by applicable law; provided, however, that, in such event, the Receiving Party provides the Disclosing Party with prompt advance notice of such disclosure (to the extent legally permitted and practicable) so that the Disclosing Party has the opportunity if it so desires to seek a protective order or other appropriate remedy.",
      },
    ],
  },
  {
    number: "7",
    title: "Termination.",
    clauses: [
      {
        letter: "a",
        title: "Termination Upon Occurrence of Certain Events.",
        text: "Either party may terminate this Agreement (i) immediately in the event of a material breach of this Agreement by the other party that is not cured within thirty (30) days of written notice thereof from the other party, or (ii) immediately if the other party ceases doing business or is the subject of a voluntary or involuntary bankruptcy, insolvency or similar proceeding, that is not dismissed within sixty (60) days of filing.",
      },
      {
        letter: "b",
        title: "Termination For Convenience.",
        text: "Either party may terminate this Agreement at any time by giving the other party at least sixty (60) days’ written notice specifying the effective date of termination.",
      },
      {
        letter: "c",
        title: "Effect of Termination.",
        text: "Upon receipt (or transmittal) of a termination notice, 9F shall (i) stop all Services, except as shall be necessary to complete portions of the Services not terminated; (ii) take any necessary action to protect property in 9F’s possession in which Client has or may acquire any interest; (iii) complete performance of the unterminated portion of the Services; and (iv) take any other action toward termination of the Services which Client may reasonably direct. Promptly following receipt (or transmittal) of a termination, Client shall pay 9F all amounts due for Services rendered and completed through the date of termination, and shall pay any other fees and reasonable expenses incurred by 9F due to such termination. Other provisions, which by their nature should survive termination of this Agreement, shall so survive, including, without limitation, Sections 2, 3, 4(a), 4(c), 4(d), 5, 6, 7, and 8.",
      },
    ],
  },
  {
    number: "8",
    title: "Miscellaneous.",
    clauses: [
      {
        letter: "a",
        title: "Use of Brand.",
        text: "Client is not authorized to disclose (or allow to be disclosed) to any third party its affiliation with 9F and Dr. Allen (including Dr. Allen's affiliation with Harvard) without the prior written consent of 9F, which may be withheld in 9F’s sole discretion, and may be conditioned upon the payment of additional fees. Without limiting the foregoing, Client shall not be permitted to use 9F’s or Dr. Allen’s name, Dr. Allen’s likeness, or 9F’s or Dr. Allen’s affiliation with Harvard, in private meetings with third parties such as those with investors, clients, tenants or government officials, or in public. Under no circumstances shall Client use or register the name “Harvard” (alone or as part of another name) or any Harvard logos, seals, or insignia in any public or private communication, including but not limited to marketing materials, investor presentations, or client meetings.",
      },
      {
        letter: "b",
        title: "Use of the Strategic Data Asset.",
        text: "Client will ensure that the Strategic Data Asset is used only in accordance with applicable local, state, federal, and international laws, industry regulations, privacy policies, notices, and statements. The Strategic Data Asset must be used with consideration of the ethical, legal, and social implications of such use and may not be used to discriminate against any individual or otherwise use the Strategic Data Asset in any way that may be harmful to any individual.",
      },
      {
        letter: "c",
        title: "Deidentified Data.",
        text: "Client will ensure that any data provided to 9F will remain at all times deidentified, and Client will not use the Strategic Data Asset to reidentify any previously deidentified data. To the extent Client shares any data with any third party, Client will ensure that any third party also contractually agrees not to reidentify or attempt to reidentify deidentified data.",
      },
      {
        letter: "d",
        title: "Compliance with Export Control Laws.",
        text: "Without limiting Section 8(b) above, Client represents that it shall comply with all United Sates laws and regulations controlling the export of certain commodities and technical data, including without limitation all Export Administration Regulations of the United States Department of Commerce. Client hereby gives written assurance that it will comply with all United States export control laws and regulations and that it will indemnify, defend, and hold 9F harmless (in accordance with Section 5) for the consequences of any such violation.",
      },
      {
        letter: "e",
        title: "No Security Interest.",
        text: "Client shall not enter into any agreement under which Client grants to or otherwise creates in any third party a security interest in this Agreement or the Strategic Data Asset. Any grant or creation of a security interest purported or attempted to be made in violation of the terms of this Section 8(e) shall be null and void and of no legal effect.",
      },
      {
        letter: "f",
        title: "Severability.",
        text: "If any provision of this Agreement is determined by a court to be invalid or unenforceable as drafted, that provision shall be severed and the enforceability of other provisions shall not be affected.",
      },
      {
        letter: "g",
        title: "Governing Law; Waiver of Jury Trial.",
        text: "This Agreement and any disputes arising out of or relating to this Agreement will be governed by, construed and interpreted in accordance with the internal laws of the Commonwealth of Massachusetts, without regard to any choice of law principle that would require the application of the law of another jurisdiction. The parties agree that any dispute arising from or relating to the subject matter of this Agreement shall be governed by the exclusive jurisdiction and venue of the state and federal courts of the Commonwealth of Massachusetts.. Each of Client and 9F hereby waive their rights to a trial by jury in any action, proceeding or counterclaim brought by either of the parties hereto against the others or their successors in respect of any matter arising hereunder.",
      },
      {
        letter: "h",
        title: "Assignment.",
        text: "Each party acknowledges that the other party has entered into this Agreement in reliance upon the particular reputation and expertise of such party. 9F agrees that if particular individuals are named in this Agreement or any Proposal for Services, none of said named persons (or any person who may be substituted in their stead with Client permission) shall be removed from his/her particular assignment in the performance of this Agreement without Client prior written consent. Neither party shall assign this Agreement without the other party’s prior written consent, which shall not be unreasonably withheld. This Agreement shall be binding upon and for the benefit of Client, 9F and their permitted successors and assigns. Notwithstanding the foregoing, this Agreement is not intended to confer, and does not confer, any rights or benefits on any third party beneficiary.",
      },
      {
        letter: "i",
        title: "Entire Agreement.",
        text: "This Agreement, together with the Proposal for Services which is incorporated herein, constitutes the entire agreement between the parties with respect to the specific subject matter of this Agreement and all prior agreements, representations and negotiations, oral or written, with respect to such subject matter are superseded. Any delay in enforcing a party’s rights under this Agreement, or any waiver as to a particular default or other matter, will not constitute a waiver of such party’s rights to the future enforcement of its rights under this Agreement, except with respect to an express written waiver relating to a particular matter for a particular period of time signed by an authorized representative of the waiving party, as applicable. The headings to the sections of this Agreement are for ease of reference only and shall not affect the interpretation or construction of this Agreement.",
      },
      {
        letter: "j",
        title: "Counterparts; Electronic Signatures.",
        text: "This Agreement may be executed in multiple counterparts, each of which shall be deemed to be an original and all of which shall be deemed to be an original instrument. Once signed, any reproduction of this Agreement made by reliable means (e.g., photocopy, facsimile) shall be considered an original.",
      },
      {
        letter: "k",
        title: "Independent Contractors.",
        text: "9F and Client are independent contractors, and nothing in this Agreement shall be construed as making them partners or creating the relationships of employer and employee, master and servant, or principal and agent between them, for any purpose whatsoever. Neither party shall make any contracts, warranties or representations or assume or create any obligations, express or implied, in the other party's name or on its behalf.",
      },
      {
        letter: "l",
        title: "Force Majeure.",
        text: "Except for the obligation to make payments, nonperformance of either party shall be excused to the extent that performance is rendered impossible by strike, fire, flood, governmental acts or orders or restrictions, failure of suppliers, or any other reason where failure to perform is beyond the reasonable control of the non-performing party. Client acknowledges and agrees that if any phase of the scheduled Services as set forth in the Proposal for Services is delayed by more than 48 hours by any act or omission of Client including but not limited to Client failure to make payments hereunder, the scheduled completion of the Services or individual phases of the Services as set forth in the Proposal for Services may be delayed. Client agrees to pay 9F compensation for any such extended work at 9F’s then standard rates for the required personnel. Client will not be responsible for any extension period that is caused by circumstances within 9F’s control.",
      },
      {
        letter: "m",
        title: "Notices.",
        text: "Any demand, notice, consent, or other communication required by this Agreement must be given in writing and shall be deemed delivered upon receipt when delivered personally or upon confirmation of receipt following delivery by internationally recognized overnight courier service, in each case addressed to the receiving party as follows:",
      },
    ],
  },
];

function hasAcceptedTerms() {
  if (typeof window === "undefined") return false;

  try {
    return (
      window.localStorage.getItem(TERMS_ACCEPTANCE_STORAGE_KEY) === "accepted"
    );
  } catch {
    return false;
  }
}

function TermsGate({ bypass = false, children }) {
  const [hasAccepted, setHasAccepted] = useState(hasAcceptedTerms);
  const [hasReachedEnd, setHasReachedEnd] = useState(false);
  const [hasCheckedAgreement, setHasCheckedAgreement] = useState(false);
  const checkboxRef = useRef(null);

  const handleDocumentScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    const isAtEnd = scrollHeight - scrollTop - clientHeight <= 12;

    if (isAtEnd) {
      setHasReachedEnd(true);
    }
  };

  const handleAccept = () => {
    if (!hasReachedEnd || !hasCheckedAgreement) {
      checkboxRef.current?.focus();
      return;
    }

    try {
      window.localStorage.setItem(
        TERMS_ACCEPTANCE_STORAGE_KEY,
        "accepted"
      );
    } catch {
      // If storage is unavailable, keep the acceptance for this app session.
    }

    setHasAccepted(true);
  };

  if (bypass || hasAccepted) return children;

  return (
    <main className="terms-gate">
      <div className="terms-gate__ambient terms-gate__ambient--cyan" />
      <div className="terms-gate__ambient terms-gate__ambient--violet" />

      <section
        className="terms-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
        aria-describedby="terms-modal-description"
      >
        <header className="terms-modal__header">
          <div className="terms-modal__brand" aria-label="Twin">
            <img src={twynLogo} alt="" className="terms-modal__logo" />
            <span className="terms-modal__brand-name">Twin</span>
          </div>

          <div className="terms-modal__heading-row">
            <div>
              <p className="terms-modal__eyebrow">Before you continue</p>
              <h1 id="terms-modal-title">Terms &amp; Conditions</h1>
              <p
                id="terms-modal-description"
                className="terms-modal__description"
              >
                Please review and accept these terms before entering the Twin
                platform.
              </p>
            </div>
          </div>
        </header>

        <div
          className="terms-modal__document"
          role="document"
          aria-label="Terms and Conditions document"
          tabIndex="0"
          onScroll={handleDocumentScroll}
        >
          <div className="terms-document__title">
            <h2>
              Standard Terms and Conditions for
              <br />
              Professional Services and Strategic Data Asset
            </h2>
          </div>

          {introductoryParagraphs.map((paragraph, index) => (
            <p key={`intro-${index}`} className="terms-document__intro">
              {paragraph}
            </p>
          ))}

          {termsSections.map((section) => (
            <section key={section.number} className="terms-document__section">
              <h3>
                <span>{section.number}.</span>
                {section.title}
              </h3>

              {section.clauses.map((clause) => (
                <p
                  key={`${section.number}-${clause.letter}`}
                  className="terms-document__clause"
                >
                  <span className="terms-document__clause-marker">
                    ({clause.letter})
                  </span>
                  <span>
                    <strong>{clause.title}</strong> {clause.text}
                  </span>
                </p>
              ))}
            </section>
          ))}
        </div>

        <footer className="terms-modal__footer">
          <label
            className={`terms-agreement ${
              hasReachedEnd ? "" : "terms-agreement--disabled"
            }`}
          >
            <input
              ref={checkboxRef}
              type="checkbox"
              disabled={!hasReachedEnd}
              checked={hasCheckedAgreement}
              onChange={(event) =>
                setHasCheckedAgreement(event.target.checked)
              }
            />
            <span className="terms-agreement__control" aria-hidden="true">
              <span>✓</span>
            </span>
            <span>
              I have read and agree to the Terms &amp; Conditions.
              <small>
                {hasReachedEnd
                  ? "Your acceptance will be saved in this browser."
                  : "Scroll to the bottom of the terms to enable acceptance."}
              </small>
            </span>
          </label>

          <button
            type="button"
            className="terms-modal__accept"
            disabled={!hasReachedEnd || !hasCheckedAgreement}
            onClick={handleAccept}
          >
            Agree &amp; Continue
          </button>
        </footer>
      </section>
    </main>
  );
}

export default TermsGate;
